/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Playdata_Eventreport_Example_Item31Inputs */

const ja_playdata_eventreport_example_item31 = /** @type {(inputs: Playdata_Eventreport_Example_Item31Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`時間帯別の同時視聴者数`)
};

const en_playdata_eventreport_example_item31 = /** @type {(inputs: Playdata_Eventreport_Example_Item31Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Viewers based on time of day`)
};

/**
* | output |
* | --- |
* | "Viewers based on time of day" |
*
* @param {Playdata_Eventreport_Example_Item31Inputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
const playdata_eventreport_example_item31 = /** @type {((inputs?: Playdata_Eventreport_Example_Item31Inputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Playdata_Eventreport_Example_Item31Inputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ja") return ja_playdata_eventreport_example_item31(inputs)
	return en_playdata_eventreport_example_item31(inputs)
});
export { playdata_eventreport_example_item31 as "playdata_eventReport_example_item3" }